"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactSvg = _interopRequireDefault(require("react-svg"));

var CardHeader =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2["default"])(CardHeader, _PureComponent);

  function CardHeader() {
    (0, _classCallCheck2["default"])(this, CardHeader);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(CardHeader).apply(this, arguments));
  }

  (0, _createClass2["default"])(CardHeader, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          svgName = _this$props.svgName,
          svgUrl = _this$props.svgUrl;
      var url;

      if (svgUrl) {
        url = svgUrl;
      } else if (svgName) {
        url = "https://static.ux.cimpress.io/assets/icons/".concat(svgName, ".svg");
      }

      return _react["default"].createElement("div", {
        style: {
          padding: '8.5px 1px',
          maxWidth: '220px',
          margin: '0 auto',
          textAlign: 'center',
          position: 'relative'
        }
      }, _react["default"].createElement(_reactSvg["default"], {
        path: "https://static.ux.cimpress.io/assets/icons/card_icon_bg.svg"
      }), _react["default"].createElement(_reactSvg["default"], {
        path: url,
        style: {
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '24px',
          height: '24px'
        }
      }));
    }
  }]);
  return CardHeader;
}(_react.PureComponent);

exports["default"] = CardHeader;
CardHeader.propTypes = {
  svgUrl: _propTypes["default"].string,
  svgName: _propTypes["default"].string
};